import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=7794f0f6&scoped=true&"
import script from "./Channel.vue?vue&type=script&lang=ts&"
export * from "./Channel.vue?vue&type=script&lang=ts&"
import style0 from "./Channel.vue?vue&type=style&index=0&id=7794f0f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7794f0f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
